import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { getUrlWithVersion } from '../../../api/api'
import { PaginatedConfigChangeHistory } from '../../../types/configChangeHistory'

export const fetchConfigChangeHistory = createAsyncThunk<
    { productId: string; data: PaginatedConfigChangeHistory },
    {
        productId: string
        from?: string
        to?: string
        login?: string
        status?: string
        page?: number
        limit?: number
    },
    ThunkConfig<string>
>(
    'configChangeHistorySlice/fetchConfigChangeHistory',
    async (args, thunkAPI) => {
        const {
            extra: { api },
            rejectWithValue,
        } = thunkAPI

        const {
            productId,
            from,
            to,
            login,
            status,
            page = 1,
            limit = 10,
        } = args

        const loginField = login === 'All' ? null : login
        const statusField = status === 'All' ? null : status?.toLowerCase()

        try {
            const { data } = await api.get<PaginatedConfigChangeHistory>(
                getUrlWithVersion(`/products/${productId}/config/history`),
                {
                    params: {
                        from,
                        to,
                        login: loginField,
                        status: statusField,
                        page,
                        limit,
                    },
                }
            )

            return { productId, data }
        } catch (e) {
            console.error(e)
            return rejectWithValue('Failed to fetch config changes history')
        }
    }
)
